import React from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  Modal,
  Typography
} from '@mui/material';
import { setUser } from '../../store/action';
import LogoutIcon from '@mui/icons-material/Logout';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 328,
  maxWidth: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 3
};

const ModalSignout = (props) => {
  const navigate = useNavigate();

  const submit = () => {
    props.setUser(null)
    Cookies.remove('token_fkub')
    navigate('/pwa')
    props.onClose()
  }

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={{ textAlign: 'center', pt: 4 }}>
          <LogoutIcon sx={{ mb: 1 }} />
          <Typography id="modal-modal-title" variant="h6" style={{ fontWeight: 'bold' }}>
            Keluar
          </Typography>
        </Box>
        <Box >
          <Box sx={{ p: '24px' }}>
            <p style={{ margin: 0 }}>Anda akan keluar dari website, Apakah Anda yakin?</p>
          </Box>
          <Box sx={{ textAlign: 'right', mb: 2, px: 3 }}>
            <Button sx={{ color: 'black', textTransform: 'none', mr: 3 }} onClick={props.onClose}>Batal</Button>
            <Button variant="contained" style={{ backgroundColor: '#9F0102', color: 'white', textTransform: 'none' }} onClick={submit}>Keluar</Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

const mapDispatchToProps = {
  setUser
}

export default connect(null, mapDispatchToProps)(ModalSignout);
